import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core'
import isError from 'lodash-es/isError'

import { WidgetErrorComponent } from 'src/app/services/global-error-handler/widget-error/widget-error.component'
import { environment } from 'src/environments/environment'

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private zone: NgZone, private injector: Injector) {}

  handleError(error: any, duration = 10000) {
    const notifier = this.injector.get(WidgetErrorComponent)

    if (!environment.production) {
      console.error(error)
    }

    if (error) {
      this.zone.run(() => {
        if (typeof error === 'string') {
          notifier.presentToast(error, duration)
          return
        }

        const errorValue = isError(error) ? error : error.errors[0]

        switch (errorValue.extensions?.code) {
          case 'INVALID_CREDENTIALS':
            notifier.presentToast(errorValue.message)
            break

          case 'RECORD_NOT_UNIQUE':
            notifier.presentToast(`This ${errorValue.extensions?.field} already exists`)
            break
        }
      })
    }
  }
}
